import { useMemo } from 'react';

/**
 * Hook para detectar el navegador y sistema operativo
 * Retorna información útil sobre iOS, Safari y combinaciones
 */
export const useBrowserDetection = () => {
    const detection = useMemo(() => {
        if (typeof window === 'undefined') {
            return {
                isIOS: false,
                isSafari: false,
                isSafariIOS: false,
                isSafariMac: false,
                isChrome: false,
                isFirefox: false,
            };
        }

        const userAgent = window.navigator.userAgent.toLowerCase();
        
        // Detectar iOS (iPhone, iPad, iPod)
        const isIOSDevice = /iphone|ipad|ipod/.test(userAgent);
        // Detección adicional para iPad en iOS 13+ que se reporta como Mac
        const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
        const isIOS = isIOSDevice || isIPadOS;
        
        // Detectar Safari: debe tener 'safari' pero NO 'chrome' ni 'chromium'
        const hasSafari = userAgent.includes('safari');
        const hasChrome = userAgent.includes('chrome') || userAgent.includes('chromium');
        const hasEdge = userAgent.includes('edg');
        const isSafari = hasSafari && !hasChrome && !hasEdge;
        
        // Detectar otros navegadores
        const isChrome = hasChrome && !hasEdge;
        const isFirefox = userAgent.includes('firefox');
        
        // Combinaciones útiles
        const isSafariIOS = isIOS && isSafari;
        const isSafariMac = !isIOS && isSafari;
        
        return {
            isIOS,
            isSafari,
            isSafariIOS,
            isSafariMac,
            isChrome,
            isFirefox,
        };
    }, []);

    return detection;
};

export default useBrowserDetection;
